import { useNavigate } from 'react-router-dom';

import { Survey, SurveyVariable } from '../../../../types/domainModels';

import { HeaderWithEdit } from '../HeaderWithEdit/HeaderWithEdit';

export const HiddenVariables = ({
  survey,
  surveyVariables,
}: {
  survey: Survey;
  surveyVariables: SurveyVariable[];
}): JSX.Element => {
  const navigate = useNavigate();

  return (
    <div className="space-y-2">
      <HeaderWithEdit
        onClickEdit={() => {
          const variableId =
            surveyVariables.length > 0 ? `/${surveyVariables[0].id}` : '';

          navigate(`/surveys/${survey.id}/build/variables${variableId}`);
        }}
        title="Variables"
      />
      {surveyVariables.length === 0 && (
        <p className="text-dark-grey">No variables</p>
      )}
      {surveyVariables.map(({ quotas, segments, title }, i) => {
        return (
          <div key={i}>
            <p className="italic">{title}</p>
            <ul className="list-disc pl-8">
              {segments.map(({ quotaId, title }, i) => {
                const quota = quotas.find(({ id }) => id === quotaId);
                let quotaStr = '';

                if (quota) {
                  if (quota.type === 'all') {
                    quotaStr = '(All)';
                  } else if (quota.type === 'at_most') {
                    quotaStr = `(At most ${quota.numberNeeded})`;
                  } else if (quota.type === 'none') {
                    quotaStr = '(None)';
                  }
                }

                return (
                  <li key={i}>
                    {title}
                    {quotaStr && ` ${quotaStr}`}
                  </li>
                );
              })}
            </ul>
          </div>
        );
      })}
    </div>
  );
};
